import { TIMESTAMP_RESET_URLS } from 'utils/constants'
import Api from './axiosInstance'

export const importMasterBarcodesApi = (data: any) =>
  Api.post({
    url: TIMESTAMP_RESET_URLS.IMPORT_MASTER,
    data,
    headers: { 'Content-Type': 'multipart/form-data' },
  })

export const importInventoryBarcodesApi = (stores: string[]) => (data: any) =>
  Api.post({
    url: TIMESTAMP_RESET_URLS.IMPORT_INVENTORY(stores),
    data,
    headers: { 'Content-Type': 'multipart/form-data' },
  })

export const importPricingBarcodesApi =
  (stores: string[], aggregator: string) => (data: any) =>
    Api.post({
      url: TIMESTAMP_RESET_URLS.IMPORT_PRICING(stores, aggregator),
      data,
      headers: { 'Content-Type': 'multipart/form-data' },
    })

export const resetAllInventoryApi = (stores: string[]) =>
  Api.post({ url: TIMESTAMP_RESET_URLS.RESET_INVENTORY(stores) })

export const resetAllPricingApi = (stores: string[], aggregator: string) =>
  Api.post({ url: TIMESTAMP_RESET_URLS.RESET_PRICING(stores, aggregator) })
